module.exports = require("node-object-hash");